import { HttpErrorResponse } from '@angular/common/http';
import { TimeoutError } from 'rxjs';

/**
 * Corte por tempo da gravação de série. O HttpClient não traz timeout, e um
 * socket morto no Android fica pendurado até o sistema o matar. 8s é cerca de
 * três vezes o p99 das gravações que funcionam, logo não corta requisição
 * saudável. Partilhado entre o retry inline (WorkoutStore) e o reenvio da fila
 * (SeriesSaveOutbox) para o corte ser o mesmo nos dois.
 */
export const SERIES_SAVE_TIMEOUT_MS = 8_000;

/**
 * Só se repete/enfileira o que não teve resposta. Um 4xx ou 5xx é resposta:
 * repetir não muda o veredito. `status: 0` é a rede caída; `TimeoutError` é o
 * corte por tempo acima.
 */
export function isUnansweredSeriesSave(error: unknown): boolean {
  return (error instanceof HttpErrorResponse && error.status === 0) || error instanceof TimeoutError;
}
